import * as Sentry from '@sentry/react';
import {
    API_URL_WHEELS,
    API_URL_WS_FORMULAIRE,
    APP_URL_PASS,
    DOCUMENTS_URL,
    SERVICES_URL
} from '../constants';

const ignoreErrors = [
    // Erreurs réseau non critiques
    'Network Error',
    'NetworkError',
    'Failed to fetch',
    'Load failed',
    'Loading chunk',
    'ChunkLoadError',

    // Erreurs HTTP côté client (4xx)
    // /4[0-9]{2}/, // Toutes les erreurs 4xx
    'Request failed with status code 422',
    // 'Request failed with status code 400',
    'Request failed with status code 401',
    'Request failed with status code 403',
    // 'Request failed with status code 404',
    'Request failed with status code 429', // Rate limiting

    // Erreurs de navigation/browser
    'Navigation cancelled',
    'Non-Error promise rejection captured',
    'Cancelled',
    'AbortError',

    // Script loading (CDN, extensions browser)
    'Script error',
    'Script error.',
    /extension\//i,
    /^moz-extension:\/\//,
    /^chrome-extension:\/\//,

    // Erreurs UI non critiques
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    /Blocked a frame with origin/,

    // Erreurs DOM causées par extensions navigateur (Google Translate, etc.)
    'NotFoundError: The object can not be found here',
    "NotFoundError: Failed to execute 'removeChild' on 'Node'",
    "NotFoundError: Failed to execute 'insertBefore' on 'Node'",
];

export const sentryInit = () => {
    Sentry.init({
        enabled: true,
        dsn: import.meta.env.VITE_SENTRY_DSN || '',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        ignoreErrors,
        // Performance Monitoring
        tracesSampleRate: 0.01, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // Session Replay
        replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        tracePropagationTargets:[
            APP_URL_PASS,
            API_URL_WHEELS,
            SERVICES_URL,
            API_URL_WS_FORMULAIRE,
            DOCUMENTS_URL
        ]
    });
};
